import PropTypes from 'prop-types';
import Logo from 'components/logo';
import LogoMain from 'components/logo/LogoMain';

export default function DrawerHeader({ open }) {
  return (
    <div className={`flex ${open ? 'justify-start px-6' : 'justify-center px-2'} py-4`}>
      <LogoMain isLight={true}  isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
    </div>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
